import { Box, Grid, Skeleton } from '@mui/material';

const DashboardSkeleton = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        {Array.from({ length: 6 }).map((_, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Skeleton variant="rounded" width="100%" height={150} animation="wave" />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4 }}>
        <Skeleton variant="rectangular" width="100%" height={300} animation="wave" />
      </Box>
    </Box>
  );
};

export default DashboardSkeleton;